import {Store} from '../../typings';
import {DesignType} from '@categoryProduct/store/design/types';

const isCustomerDesign = (store: Store) => store.design.designType === DesignType.CUSTOMER_DESIGN;

export default isCustomerDesign;
